// extracted by mini-css-extract-plugin
export default {"title":"df5a7ddf93","bld":"_7e652d44a9"};